import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';
import { slider } 		from './theme/components/slider.js';
import { gift } 		from './theme/components/gift.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	
	init: function () {
		var self = this;

		// Global
		self.onloadClass();
		self.touch();
		self.smoothScroll.init();

		self.copyAf();


		self.cartCouponIf();

		self.moveSearch();
		//self.closeSearch();

		hamburger.init();
		slider.init();
		gift.init();

		theme.switcherPosition();

		

		self.smartform();

		if( jQuery( 'td.product-quantity' ).length ) {
			jQuery( '.button--stack' ).each(function(){
				jQuery(this).closest( 'td.product-quantity').append( jQuery(this) );
			});
		}

		if( jQuery( '.button.button--stack' ).length ) {
			jQuery( '.woocommerce-product-details__short-description p' ).each(function(){
				if( jQuery(this).text().includes( '✔' ) ) {
					jQuery(this).addClass( 'special' );
				}
			});
		}


		
		
		if( jQuery( '.term-description' ).length ) {
			jQuery( '.term-description' ).appendTo( '.woo-sikmo > .container' );
			jQuery( '.woo-sikmo .term-description' ).addClass( 'moved' );
		}

		jQuery( '.country-switchero__handle' ).on( 'click', function(){
			jQuery( 'body' ).toggleClass( 'view-country-switchero' );
		});

		jQuery( document ).on( 'click', '.button--plus, .button--minus, .button--stack', function() {
 
			// Get current quantity values
			var qty 	= jQuery( this ).parent().find( '.qty' );
			var val   	= parseFloat( qty.val() );
			var max 	= parseFloat( qty.attr( 'max' ) );
			var min 	= parseFloat( qty.attr( 'min' ) );
			var step 	= parseFloat( qty.attr( 'step' ) );
 
			if( jQuery( this ).hasClass( 'button--stack' ) ) {
				step = parseFloat( jQuery( this ).data('count') );
			}

			// Change the value if plus or minus
			if ( jQuery( this ).hasClass( 'button--plus' ) || jQuery( this ).hasClass( 'button--stack' ) ) {
			   	if ( max && ( max <= val ) ) {
					qty.val( max );
			   	} else {
			   		qty.val( val + step );
				}

				if( qty.val() > max ) {
					qty.val(max );
				}
			} else {
			   	if ( min && ( min >= val ) ) {
				  	qty.val( min );
			   	} else if ( val > 1 ) {
					qty.val( val - step );
			   	}
			}
			 
			if( jQuery( '[name="update_cart"][disabled]' ) ) {
				jQuery( '[name="update_cart"]' ).removeAttr( 'disabled' );
				jQuery( '[name="update_cart"]' ).attr( 'aria-disabled', false );
			}
		});

		jQuery('div.woocommerce').on('click', 'input.qty', function(){
            jQuery("[name='update_cart']").trigger("click");
        });

		// TODO:
		jQuery( '.header-special-message__close' ).on( 'click', function(e){
			e.preventDefault();
			helpers.setCookie( 'hide-header-special-message', true, 1 );

			jQuery( '.header-special-message' ).remove();
			jQuery( '.header--has-message' ).removeClass( 'header--has-message' );
		});

		if( helpers.getCookie( 'hide-header-special-message' ) ) {
			jQuery( '.header-special-message' ).remove();
			jQuery( '.header--has-message' ).removeClass( 'header--has-message' );
		}






		jQuery( document ).on( 'click', '.js-load', function(e) {
			e.preventDefault();
			jQuery(this).closest('.js-loadParent').addClass('active');
			jQuery(this).remove();
			

		});
	},


	cartCouponIf: function() {
		var checkoutButton = document.querySelector(".checkout-button");
		if( checkoutButton ) {
			checkoutButton.addEventListener("click", function(e) {
				e.preventDefault(); 
		
				var cartDiscountExists = document.querySelector(".shop_table .cart-discount") !== null;
				var scCouponExists = document.querySelector(".sc-coupon") !== null;
		
				if (!cartDiscountExists && scCouponExists) {
					var userConfirmation = confirm("Máte nevyužitý slevový kupon, přejete si i přesto pokračovat?");
					if (userConfirmation) {
						window.location.href = checkoutButton.getAttribute('href');
					}
				} else {
					window.location.href = checkoutButton.getAttribute('href');
				}
			});
		}
	},

	switcherPosition: function() {
		var headerElement = document.querySelector('.header');
		var switcheroElement = document.querySelector('.country-switchero');

		if (headerElement && switcheroElement) {
		var headerHeight = headerElement.offsetHeight;
		switcheroElement.style.top = (headerHeight + 15) + 'px';
		}
	},

	copyAf: function() {
		let copyButton = document.querySelector('.js-copy-af-link');
		let copyInput = document.querySelector('.js-af-link');
		if( copyButton ) {
			copyButton.addEventListener('click', async function(e) {
				e.preventDefault();
			
				let copyText = copyInput.value;
				try {
					await navigator.clipboard.writeText(copyText);
					copyButton.classList.add('copied');
			
					setTimeout(function() {
						copyButton.classList.remove('copied');
					}, 2000);
				} catch (err) {
					console.error('Failed to copy text: ', err);
				}
			});
		}
	},

	moveSearch: function () {
		
		jQuery( ".navigation__item--h-search" ).append( jQuery( ".js-search" ) );

		jQuery( document ).on( "click", 'a[ href="/?s="]' , function( event ) {
			event.preventDefault();
			
			jQuery(".js-search").fadeIn();
			jQuery(".js-search .container").addClass("active");
			jQuery(".js-search input[type=search]").focus();
        });
	},
	
	closeSearch: function () {
		jQuery( document ).on( "click", ".js-search" , function( event ) {

			if (!jQuery(event.target).closest(".js-search .container").length) {
				jQuery(".js-search").fadeOut();
				jQuery(".js-search .container").removeClass("active");
			}
        });

		jQuery(document).keyup(function(e) {
			if(jQuery(".js-search").length) {
				if (e.key === "Escape") {
					jQuery(".js-search").fadeOut();
					jQuery(".js-search .container").removeClass("active");
				}
			}
	   });
	},

	smartform: function() {
		var smartform = smartform || {};

		smartform.beforeInit = function initialize() {
			smartform.setClientId('0FJFXBcE8n');
		};
		jQuery(document).ready(function ($) {
	
			/** SMARTFORM */
			$('#billing_address_1').addClass("smartform-instance-zakaznik smartform-street-and-number");
			$('#billing_city').addClass("smartform-instance-zakaznik smartform-city");
			$('#billing_postcode').addClass("smartform-instance-zakaznik smartform-zip");
			$('#shipping_address_1').addClass("smartform-instance-dodaci smartform-street-and-number");
			$('#shipping_city').addClass("smartform-instance-dodaci smartform-city");
			$('#shipping_postcode').addClass("smartform-instance-dodaci smartform-zip");
	
			/** Nastavení našeptávače podle počátečního výběru */
			smartform.afterInit = function () {
				var country = $("#billing_country").val();
				smartform.getInstance('smartform-instance-zakaznik').setCountry(country);
				country = $("#shipping_country").val();
				smartform.getInstance('smartform-instance-dodaci').setCountry(country);
			};
		  
			/** Nastavení našeptávače podle při změně*/
			$("#billing_country").change(function () {
				var country = $("#billing_country").val();
				if (country == "CZ" || country == "SK") {
					smartform.getInstance('smartform-instance-zakaznik').setAllOraclesEnabled(true);
					smartform.getInstance('smartform-instance-zakaznik').setCountry(country);
					  if (country != "CZ"){
					$("#billing_dic, #billing_dic_field label, #billing_ic, #billing_ic_field label").hide();
					} else {
					$("#billing_dic, #billing_dic_field label, #billing_ic, #billing_ic_field label").show();
					}
				} else {
					smartform.getInstance('smartform-instance-zakaznik').setAllOraclesEnabled(false);
					  $("#billing_dic, #billing_dic_field label, #billing_ic, #billing_ic_field label").hide();
				}
			});
	
			$("#shipping_country").change(function () {
				var country = $("#shipping_country").val();
				if (country == "CZ" || country == "SK") {
					smartform.getInstance('smartform-instance-dodaci').setAllOraclesEnabled(true);
					smartform.getInstance('smartform-instance-dodaci').setCountry(country);
				} else {
					smartform.getInstance('smartform-instance-dodaci').setAllOraclesEnabled(false);
				}
			});
			$('#billing_phone, #billing_postcode, #shipping_postcode').bind('focus', function () {
				$(document.body).trigger("update_checkout");
		   });
		});
	},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},

	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: function (anchor, toggle) {
					var headerOffset = jQuery( '.header.header--p-fixed .header__row').outerHeight();

					if( jQuery( anchor ).offset().top < jQuery( window ).scrollTop() + headerOffset ) {
						headerOffset = jQuery( '.header.header--p-fixed' ).css( '--header-height' )
						headerOffset = headerOffset.replace( 'px', '');
					}

					if( !headerOffset ) {
						headerOffset = 0;
					}
	
					return headerOffset;
				},
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},

	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},

	onresize() {
		var self = this;
	},

	onscroll() {
		var self = this;
	},
};

jQuery(function() {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
	theme.switcherPosition();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 